import { UseMutateAsyncFunction } from '@tanstack/react-query'
import React, { useRef } from 'react'

import { ILogsContext, LogsContext } from './LogsContext'
import {
  CreateUserLogMutation,
  Exact,
  InputMaybe,
  UserLogDto,
} from '../../../lib/graphql'

export function LogsContextProvider({
  children,
  createUserLogMutation,
}: {
  children: React.ReactNode
  createUserLogMutation?: UseMutateAsyncFunction<
    CreateUserLogMutation,
    unknown,
    Exact<{
      userLogDto: UserLogDto
      parentId?: InputMaybe<string> | undefined
    }>,
    unknown
  >
}) {
  const parentLogId = useRef<string>()
  const createUserLog = async (userLogDto: UserLogDto) => {
    if (!createUserLogMutation) {
      return
    }
    const createUserLogResponse = await createUserLogMutation({
      userLogDto,
      parentId: parentLogId.current,
    })
    if (createUserLogResponse.createUserLog.parentId) {
      parentLogId.current = createUserLogResponse.createUserLog.parentId
    }
  }

  const setParentLog = (parentId: string | undefined) => {
    parentLogId.current = parentId
  }

  const context: ILogsContext = {
    createUserLog,
    parentLogId: parentLogId.current,
    setParentLog,
  }

  return <LogsContext.Provider value={context}>{children}</LogsContext.Provider>
}
